/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyListContainerLastFlattened_story = {
    readonly id: string;
    readonly isClosed: boolean;
    readonly closedAt: string | null;
    readonly settings: {
        readonly live: {
            readonly enabled: boolean;
        };
    };
    readonly " $fragmentRefs": FragmentRefs<"CommentContainer_story">;
    readonly " $refType": "ReplyListContainerLastFlattened_story";
};
export type ReplyListContainerLastFlattened_story$data = ReplyListContainerLastFlattened_story;
export type ReplyListContainerLastFlattened_story$key = {
    readonly " $data"?: ReplyListContainerLastFlattened_story$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainerLastFlattened_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListContainerLastFlattened_story",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isClosed",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "closedAt",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "StorySettings",
            "kind": "LinkedField",
            "name": "settings",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "LiveConfiguration",
                    "kind": "LinkedField",
                    "name": "live",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "enabled",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_story"
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = '131cb0772f01e679f2a3ffa2327de770';
export default node;
